module.exports = __webpack_public_path__ + "img/shipping-address.101a8b5a.svg";